import React from 'react';

interface GroupBoxProps {
    label?: string;
    children: React.ReactNode;
}

export const GroupBox: React.FC<GroupBoxProps> = ({ label, children }) => {
    return (
        <div style={{ border: '1px solid', padding: '10px', borderRadius: '5px', margin: '5px' }}>
            {label && <div style={{ marginBottom: '10px', fontWeight: 'bold' }}>{label}</div>}
            <div style={{ display: 'flex', gap: '5px' }}>{children}</div>
        </div>
    );
};